import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/auth.context";
import { isAdmin } from "@/lib/utils";

export default function AdminRoute() {
  const { user, loading, portalMode } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4dbd07]"></div>
      </div>
    );
  }

  // Only allow access if user is admin AND in admin portal mode
  const userIsAdmin = isAdmin(user);
  const isInAdminMode = portalMode === "admin";

  if (!userIsAdmin || !isInAdminMode) {
    return <Navigate to="/access-denied" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

